<template>
  <div class="page api">
    <div class="top">
      <div>
        <div class="icon"><i class="fa-regular fa-bookmark"></i></div>
        <div class="title">
          <span>{{ title }}</span>
        </div>
      </div>
      <div class="actions">
        <button
          class="btn-cat"
          @click="
            () => {
              search = ''
              getApi('mobi', limit, 1)
              select = 'mobi'
            }
          "
          :class="{ active: select === 'mobi' }"
        >
          Mobis
        </button>
        <button
          class="btn-cat"
          @click="
            () => {
              search = ''
              getApi('badge', limit, 1)
              select = 'badge'
            }
          "
          :class="{ active: select === 'badge' }"
        >
          Emblemas
        </button>
        <div class="search-wrap">
          <i class="fa-solid fa-magnifying-glass"></i>
          <input
            type="text"
            name="search"
            v-model="search"
            @change="getApi(select, limit, 1, search)"
            @keydown.enter="getApi(select, limit, 1, search)"
            placeholder="Pesquisar..."
          />
        </div>
        <button :disabled="disableP || loading" @click="getApi(select, limit, prev)">
          <i class="fa-solid fa-angle-left"></i>
        </button>
        <button :disabled="disableN || loading" @click="getApi(select, limit, next)">
          <i class="fa-solid fa-angle-right"></i>
        </button>
      </div>
    </div>
    <div class="content" v-if="loading">
      <div class="box" v-for="i in limit" :key="'sk-' + i">
        <Sk w="100%" h="100%" rounded="rounded-xl" extra="!w-full !h-full min-w-[65px] min-h-[65px]" />
      </div>
    </div>
    <div class="content" v-else-if="select === 'mobi' && mobs.length > 0">
      <div class="box" v-for="(m, index) in mobs" :key="index" :class="{ new: m.new }">
        <img
          :alt="m.id_mob"
          :src="mobIconUrl(m)"
        />
        <MyTip
          :title="apiTooltip(m, m.id_mob)"
          top="-90px"
          line="26px"
        />
      </div>
    </div>
    <div class="content" v-else-if="select === 'badge' && badges.length > 0">
      <div class="box" v-for="(b, index) in badges" :key="index" :class="{ new: b.new }">
        <img
          :alt="b.code"
          :src="badgeImageUrl(b)"
        />
        <MyTip
          :title="apiTooltip(b, b.code)"
          top="-90px"
          line="26px"
        />
      </div>
    </div>
  </div>
</template>

<script setup>

import MyTip from '@/components/usefulness/tooltip.vue'
import Sk from '@/components/usefulness/Sk.vue'
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { getHabbletBadges, getHabbletMobs, mapHabbletBadge, mapHabbletMob, badgeImageUrl, mobIconUrl } from '@/services/api.js'
import { trackEvent } from '@/services/analytics.js'

const route = useRoute()
const rota =
  route.query?.tipo && (route.query?.tipo === 'badge' || route.query?.tipo === 'mobi')
    ? route.query?.tipo
    : 'badge'

const select = ref(rota)
const title = ref('Emblemas')
const mobs = ref([])
const badges = ref([])
const limit = ref(96)
const disableP = ref(false)
const disableN = ref(false)
const prev = ref(0)
const next = ref(0)
const search = ref(route.query?.s ?? '')
const loading = ref(true)
let apiViewTracked = false

function apiTooltip(item, idLabel) {
  let html =
    idLabel +
    '<br><hr><span class=\'subtitle\'>' +
    item.name +
    '</span><br><span class=\'desc\'>' +
    item.description +
    '</span>'
  if (item.discovered_at) {
    html += '<br><span class=\'desc\'>Descoberto em ' + item.discovered_at + '</span>'
  }
  return html
}

async function getApi(api, limitVal, pag) {
  loading.value = true
  select.value = api

  try {
    if (api === 'mobi') {
      badges.value = []
      title.value = 'Mobis'

      const d1 = await getHabbletMobs({ page: pag, limit: limitVal, search: search.value })
      mobs.value = (d1.data ?? []).map(mapHabbletMob)

      prev.value = d1.pagination?.prev ?? 0
      next.value = d1.pagination?.next ?? 0

      disableP.value = prev.value === 0
      disableN.value = next.value === 0
    } else {
      mobs.value = []
      title.value = 'Emblemas'

      const d2 = await getHabbletBadges({ page: pag, limit: limitVal, search: search.value })
      badges.value = (d2.data ?? []).map(mapHabbletBadge)

      prev.value = d2.pagination?.prev ?? 0
      next.value = d2.pagination?.next ?? 0

      disableP.value = prev.value === 0
      disableN.value = next.value === 0
    }

    if (!apiViewTracked) {
      apiViewTracked = true
      trackEvent('api_page_view', { api_type: api })
    }
  } finally {
    loading.value = false
  }
}

getApi(select.value, limit.value, 1)

watch(() => [route.query?.tipo, route.query?.s], ([newTipo, newSearch]) => {
  select.value = newTipo ?? 'badge'
  search.value = newSearch ?? ''
  getApi(select.value, limit.value, 1)
})
</script>

<style scoped>
.api .top {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.api .top .icon {
  background-image: none;
  background-color: rgb(7, 221, 193);
}

.api .top .actions {
  position: relative;
  right: 0;
  width: 60%;
  display: flex;
  justify-content: space-between;
}

.api .top .actions button {
  float: left;
  width: 36px;
  height: 36px;
  border-radius: 30px;
  background-color: #d7dde4;
  font-size: 14px;
  text-align: center;
  line-height: 36px;
  color: #bdc4cd;
}

.api .top .actions button.btn-cat {
  width: auto;
  padding: 0 10px;
  background-color: #e7ebf0;
  color: #505f6c;
  font-weight: 600;
  transition: all 0.4s ease;
}

.api .top .actions button.btn-cat.active,
.api .top .actions button.btn-cat:hover {
  background-color: var(--color1);
  color: #fff;
}

.api .top .actions .search-wrap > i {
  position: absolute;
  margin: 12px 0 0 14px;
  font-size: 13px;
}

.api .top .actions .search-wrap > input {
  float: left;
  width: 170px;
  height: 36px;
  background-color: #fff;
  border-radius: 20px;
  padding-left: 36px;
}

@media (max-width: 1199px) {
  .api .top {
    flex-direction: column;
    gap: 8px;
  }

  .api .top .actions {
    width: 100%;
    flex-wrap: wrap;
    gap: 8px;
  }

  .api .top .actions button.btn-cat {
    flex: 1;
    text-align: center;
    order: 1;
  }

  .api .top .actions .search-wrap {
    order: 2;
    width: 100%;
    position: relative;
  }

  .api .top .actions .search-wrap > i {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    margin: 0;
    pointer-events: none;
  }

  .api .top .actions .search-wrap > input {
    width: 100%;
    padding-left: 36px;
  }

  .api .top .actions button:not(.btn-cat) {
    order: 3;
  }
}

.api .content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.api .content .box {
  float: left;
  position: relative;
  width: 65px;
  height: 65px;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #ccc;
  border-radius: 12px;
  margin-top: 5px;
  transition: all 0.3s ease;
}

.api .content .box:hover {
  background-color: #2fc145;
}

.api .content .box.new {
  background-color: var(--color1);
}

.api .content .box img {
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
